class LoyaltyService {
  static base = '';

  static getLoyalties = () => `${this.base}/loyalties`;

  static getCashbackLoyalty = () => `${this.base}/loyalties?cashback=true`;
}

export default LoyaltyService;
